<script type="text/javascript">

export default {
    data() {
        return {

        }
    },
    computed: {
        tags() {
            return this.$store.getters['sendables/getAvailableTags'];
        },
        sendable() {
            return this.$store.getters['sendables/getSendable'];
        },
    },
    mounted() {
    },
    methods: {
        openSendableInfoTagModal(){
            this.$event_bus.$emit('openSendableInfoTagModal');
        },
        insertTag(tag){
            this.$emit('insertTag', tag)
        }
    },
};
</script>

<template id="sendable-tags-input">

    <div class="sendable-available-tags form-group" v-if="tags.length">

        <label for="" class="control-label truncate">{{  trans('sendables.available_tags') }}</label>

        <span class="mention btn-custom btn-trans btn m-b-5 m-r-5 sendable-tag"  v-for="tag in tags">
            <a v-tooltip="tag.description" href=""  @click.prevent="insertTag(tag)">
                {{ tag.id }}
            </a>

            <a href="" style="border-left: 1px solid var(--secondary-color);" v-if="tag.id === '@info' && sendable" @click.prevent="openSendableInfoTagModal"><i class="zmdi zmdi-edit m-l-5" ></i></a>
        </span>

    </div>

</template>
